import { useCallback } from "react";

export const useAnonymousSession = () => {
  const hasAnonymousSession = useCallback(() => {
    return localStorage.getItem("anonymousSession") !== null;
  }, []);

  const isAnonymousSession = useCallback(async (sessionId) => {
    return localStorage.getItem("anonymousSession") === sessionId;
  }, []);

  const getAnonymousSession = useCallback(async (sessionId) => {
    const response = await fetch(
      `${process.env.REACT_APP_FINGERPRINTER_BASE_URL}/api/anonymous/sessions/${sessionId}`,
      {
        headers: {
          "X-User-Id": "aaaaaaa",
        },
      }
    );
    if (!response.ok) throw new Error("Failed to load sessions");
    return await response.json();
  }, []);

  const getAnonymousChat = useCallback(async (sessionId) => {
    const response = await fetch(
      `${process.env.REACT_APP_FINGERPRINTER_BASE_URL}/api/anonymous/sessions/${sessionId}/chat`,
      {
        headers: { "X-User-Id": "aaaaaaa" },
      }
    );
    if (!response.ok) throw new Error("Failed to load chat");
    return await response.json();
  }, []);

  const postAnonymousChat = useCallback(
    async (sessionId, message, lastResults, options = {}) => {
      const { useStreaming = false } = options;
      const response = await fetch(
        `${process.env.REACT_APP_FINGERPRINTER_BASE_URL}/api/anonymous/sessions/${sessionId}/chat`,
        {
          headers: { "X-User-Id": "aaaaaaa" },
          method: "POST",
          body: JSON.stringify({ message, lastResults, useStreaming }),
        }
      );
      if (!response.ok) throw new Error("Failed to create anonymous chat");
      return await response.json();
    },
    []
  );

  const createAnonymousSession = useCallback(async () => {
    const response = await fetch(
      `${process.env.REACT_APP_FINGERPRINTER_BASE_URL}/api/anonymous/sessions`,
      {
        headers: {
          "X-User-Id": "aaaaaaa",
        },
        method: "POST",
      }
    );
    if (!response.ok) throw new Error("Failed to create session");

    const { sessionId } = await response.json();

    localStorage.setItem("anonymousSession", sessionId);

    return sessionId;
  }, []);

  const queryVectorStore = useCallback(
    async (
      query,
      inferredPreferences,
      timestamp = new Date().toISOString()
    ) => {
      const response = await fetch(
        `${process.env.REACT_APP_FINGERPRINTER_BASE_URL}/api/anonymous/query`,
        {
          headers: {
            "X-User-Id": "aaaaaaa",
          },
          method: "POST",
          body: JSON.stringify({
            query,
            inferredPreferences,
            timestamp,
          }),
        }
      );
      if (!response.ok)
        throw new Error("Failed to query vector store in fingerprint api");

      return await response.json();
    },
    []
  );

  return {
    isAnonymousSession,
    hasAnonymousSession,
    createAnonymousSession,
    getAnonymousSession,
    postAnonymousChat,
    getAnonymousChat,
    queryVectorStore,
  };
};
